import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { validationMessages } from '../../messages';

@Component({
  selector: 'app-ui-phone-input',
  templateUrl: './ui-phone-input.component.html',
  styleUrls: ['./ui-phone-input.component.scss'],
  standalone: false,
})
export class UiPhoneInputComponent {
  @Input() prefixControl: FormControl<string>;
  @Input() phoneControl: FormControl<string>;

  readonly messages = validationMessages;

  get phoneError(): string | null {
    const parentForm = this.phoneControl?.parent;
    const hasError = parentForm?.hasError('invalidPhoneNumber');

    if (hasError) {
      return this.messages['invalidPhoneNumber'];
    }
    return null;
  }
}
